import React, { useEffect, useState, useContext } from "react";
import * as routes from "../constants/routes";
import queryString from "query-string";
import { Link } from "react-router-dom";
import { LoadingIndicator, Alert } from "@ufginsurance/ui-kit";
import OnlineQuotingContext from "./OnlineQuotingContext";
import "./OnlineQuotingLayout.scss";
import { useFlags } from "launchdarkly-react-client-sdk";
import { connect } from "react-redux";
import { sessionSelector } from "@ufginsurance/sso-oidc-client-react";
import withPageViewTracking from "../loggers/withPageViewTracking";

// http://localhost:8080/online_quoting/loader/0001849730
// http://localhost:8080/online_quoting/loader/2020-10-01 09:12:53.053

const QuoteLoader = ({ history, location, employeeUsername }) => {
  const [status, setStatus] = useState();

  const { getQuote, step, setStep } = useContext(OnlineQuotingContext);
  const { disableOldProQuote } = useFlags();

  const disable = !employeeUsername && disableOldProQuote;

  useEffect(() => {
    if (step) setStep(null);
    // only run once when component is loaded
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // !status and setStatus makes this effect only run one time
    if (!status) {
      setStatus("loading");

      // set step to be the number in the path. e.g "3" in  /online_quoting/step3
      const path = location.pathname;

      const regEx = `(${routes.ONLINE_QUOTING_LOADER}/)(.+)`;
      const qstringId = path.match(regEx) || [];

      const id = qstringId?.[2] || null;

      const queryStr = queryString.parse(location.search);
      const stepOverride = queryStr.step;

      if (id && id.length < 15 && !!disable) {
        setStatus("disableOldProQuote");
      } else {
        getQuote(id, ({ success, step }) => {
          const stepToUse = stepOverride || step;
          if (!success) setStatus("failure");
          else history.replace(routes.ONLINE_QUOTING + "/step" + stepToUse);
        });
      }
    }
  }, [
    getQuote,
    history,
    location,
    location.pathname,
    status,
    disableOldProQuote,
    disable
  ]);

  if (!employeeUsername && status === "disableOldProQuote")
    return (
      <Alert type="warning" dismissible={false} className="mt-1 mb-2">
        This quote can no longer be edited.&nbsp;&nbsp;
        <a
          target="_blank"
          rel="noreferrer"
          href="https://myemail.constantcontact.com/Time-saving-BOP-changes.html?soid=1115349612465&aid=645ucRjRSik"
        >
          Click here for more information
        </a>
      </Alert>
    );

  if (status === "loading")
    return (
      <LoadingIndicator
        message="Loading Quote"
        className="oq__quote-loader-wrapper"
      />
    );

  if (status === "failure")
    return (
      <div className="oq__quote-not-found">
        <h2>Unable to load quote.</h2>
        <b>We are sorry... unfortunately, we are unable load the quote.</b>
        <div>
          <Link to={routes.ONLINE_QUOTING_STEP1}>
            Click here to start a new quote.
          </Link>
        </div>
      </div>
    );

  return null;
};

const mapStateToProps = state => {
  return {
    employeeUsername: sessionSelector.getEmployeeUserName(state)
  };
};

export default withPageViewTracking(connect(mapStateToProps, {})(QuoteLoader));
